import VN from "../components/VN";
import { useContext, useState, useEffect } from "react";
import { UserDataContext } from "../components/UserDataContext";
import { Container, Table } from "react-bootstrap";
import { apiRequest } from "../components/Config";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import Alerts from "../components/Alerts";
import { Row } from "react-bootstrap";
import { marginBottom } from "../App";

export default function Categories() {
  const { userData } = useContext(UserDataContext);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);

  useEffect(() => {
    if (userData) {
      fetchData();
    }
  }, [userData]);

  const fetchData = async () => {
    try {
      const response = await apiRequest("filescategory", "GET");
      console.log("Categories: ", response);
      if (Array.isArray(response)) {
        setCategories(response);
      } else {
        setCategories([]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleShowAddCategory = () => {
    setShowAddCategory(!showAddCategory);
  };

  const values = {};
  const handleAddCategory = async (newCategory) => {
    values["category"] = newCategory;
    console.log("New category: ", values);
    try {
      const response = await apiRequest(`insertcategory`, "POST", values);
      console.log("response category: ", response);
      if (response.error_msg === 200) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Dane zaktualizowane!",
        });
        await fetchData();
      }
      if (response.error_msg === 502) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "error",
          info: "Ta kategoria już istnieje!",
        });
      }
      if (response.error_msg === 503) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Informacja",
          severity: "warning",
          info: "Nie wprowadzono danych kategorii...",
        });
      }
    } catch (error) {
      setShowApiResponse(true);
      setApiResponse({
        title: "Uwaga",
        severity: "error",
        info: "Nie udało się zaktualizować!",
      });
      console.error("There was an error editing the user!", error);
    }
  };
  return (
    <div>
      <VN userData={userData} />
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <h1>Kategorie</h1>
      <Container>
        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
                <th className="td-centered">ID</th>
                <th className="td-centered">Kategoria</th>
                <th className="td-centered">Aktywna</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((cat, index) => (
                <tr key={cat.id}>
                  <td className="td-centered">{index + 1}</td>
                  <td>{cat.category}</td>
                  <td className="td-centered">{cat.active ? "✅" : "❌"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <Button onClick={handleShowAddCategory}>
          Dodaj kategorię
          <AddIcon />
        </Button>
        {showAddCategory && (
          <>
            <h6>Dodanie nowej kategorii pliku</h6>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleAddCategory(newCategory);
                setNewCategory("");
              }}
            >
              <TextField
                name="category"
                label="Nowa kategoria"
                variant="outlined"
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
                fullWidth
              />
              <Button type="submit">Zapisz</Button>
            </form>
          </>
        )}
      </Container>
    </div>
  );
}
